import { Auth } from 'aws-amplify';
import { hasValue, safeParseJSON } from '../../../../../general/js/general-helpers';
import * as cookieHelper from '../../../helpers/cookie-helper';
import userService from '../../../../../general/js/user/user-service';
import { userDataCookieConstants } from './user-data-cookie-constants';
import eventBus from '../../../../../general/js/event-bus';
import { MembershipTypes } from '../../../../../general/js/utils';

export const getUserDataCookie = () => {
    const cookie = cookieHelper.getCookie(userDataCookieConstants.USER_DATA_COOKIE_NAME);

    if (!hasValue(cookie)) {
        return undefined;
    }

    return safeParseJSON(cookie);
};

export const getIsOneClubMemberFromCookie = () => {
    const userData = getUserDataCookie();

    if (!hasValue(userData)) {
        return false;
    }

    return userData.isOneClubMember;
};

export const updateUserDataCookie = async (emitEventBusEvent = false, bypassCache = false) => {
    await Auth.currentAuthenticatedUser({
        bypassCache
    })
        .then((user) => {
            updateUserDetailsCookie(user, emitEventBusEvent);
        })
        .catch((e) => {
            console.log(e);
        });
};

export const updateUserDetailsCookie = (user, emitEventBusEvent = false) => {
    if (!hasValue(user) || !hasValue(user.attributes)) {
        return;
    }
    const { attributes } = user;
    const isOneClub = attributes['custom:Membership'].includes(MembershipTypes.OneClub);
    const userDataCookieValue = JSON.stringify({
        firstName: attributes.given_name,
        lastName: attributes.family_name,
        isSignedIn: true,
        isOneClubMember: isOneClub,
        isRandaMember: false,
        hasRaMemberId: !!((attributes['custom:RAMemberId'] !== null && attributes['custom:RAMemberId'] !== undefined))
    });

    userService.setUserDataCookie(userDataCookieValue);

    if (emitEventBusEvent) {
        eventBus.emit(userDataCookieConstants.USER_DATA_COOKIE_CHANGE_EVENT);
    }
};
